import React, { useEffect, useState } from "react";
import Editor from "../Common/Editor";
import { showToast } from "../Common/Messages";
import SearchDocument from "../Common/SearchDocument";
import PopUp from "../Common/PopUp";
import { parseToArray } from "../libs/Util";

const FAQEditor = (props) => {
    const [workingTag, setWorkingTag] = useState('A');
    const [faqID, setFaqID] = useState('');
    const [isValid, setIsValid] = useState({ isValid: true, message: "" });
    const [faqData, setFaqData] = useState({ faqKindName: '', title: '', tag: [], data: {}, relationInfo: [] });
    const [popUpContent, setPopUpContent] = useState(null);
    const [isSideBar, setIsSideBar] = useState(true);

    useEffect(() => {
        if (props.data && props.data.faqID !== "") {
            setFaqID(props.data.faqID);
            setFaqData({
                faqKindName: props.data.faqKindName,
                title: props.data.question,
                tag: props.data.tag ? parseToArray(props.data.tag) : [],
                data: JSON.parse(props.data.answer || '{}'),
                relationInfo: props.data.relationInfo ? JSON.parse(props.data.relationInfo) : []
            })
            setWorkingTag('U');
        } else {
            setFaqID(`F${new Date().getTime()}`);
            setWorkingTag('A');
        }

        return () => {
            setFaqID("");
        }
    }, [props.data]);

    const path = (pathItem) => {
        let pathlist = [];
        pathItem.map((x,index) => {
            pathlist.push(<span className='docbox-col-path-text'>{x}</span>);                    
                if(index < pathItem.length-1)
                    pathlist.push(<i className='icoKdc12 next'></i>);
                return x;
            }                
        );

        return (
            <div className="path">
                {pathlist}
            </div>
        );
    }

    const selectFaqKind = (e) => {
        setFaqData(prev => { return { ...prev, faqKindName: e.target.value } });
    }

    const handleTitle = (e) => {
        setFaqData(prev => { return { ...prev, title: e.target.value } });
    }

    const handleEnterTag = (e) => {
        if (e.key !== "Enter" || e.nativeEvent.isComposing) {
            return;
        }
        const tag = e.target.value.trim();
        if (!tag || tag === "") {
            e.target.value = "";
            showToast('warning', "태그를 입력해주세요.");
            return;
        }

        for (let i = 0; i < faqData.tag.length; i++) {
            if (faqData.tag[i] === tag) {
                e.target.value = "";
                showToast('warning', "중복된 태그입니다.");
                return;
            }
        }
        setFaqData(prev => {
            const prevTagList = prev.tag ?? [];
            return { ...prev, tag: [...prevTagList, tag] }
        });
        e.target.value = "";
    };
    const handleDeleteTag = (tag) => {
        const list = faqData.tag.filter(t => t !== tag);
        setFaqData(prev => { return { ...prev, tag: list } });
    };

    const openSearchDoc = (e) => {
        setPopUpContent(<SearchDocument from={"menu"} type={"relation"} documents={faqData.relationInfo || []} 
            addItem={addRelatedDoc} removeItem={removeRelatedDoc} fnBtnOnPopup={() => setPopUpContent(null)} />);
    }
    const removeRelatedDoc = (item) => {
        const relatedDocumentData = faqData.relationInfo.filter(doc => doc.manualId !== item.manualId);
        setFaqData(prev => { return { ...prev, relationInfo: relatedDocumentData } });
    }

    const addRelatedDoc = (item) => {
        setFaqData(prev => { return { ...prev, relationInfo: [...prev.relationInfo, item] } });
    }

    const checkValid = () => {
        if (!faqData.faqKindName || faqData.faqKindName === "") {
            showToast('warning', "카테고리를 선택해주세요.");
            return false;
        }
        if (!faqData.title || faqData.title === "") {
            showToast('warning', "제목을 입력해주세요.");
            return false;
        }
        if (!isValid.isValid) {
            showToast('warning', isValid.message);
            return false;
        }
        return true;
    }

    const handleSubmit = async () => {
        if (!checkValid()) return;

        const data = {
            workingTag: workingTag,
            faqID: faqID,
            faqKindName: faqData.faqKindName,
            question: faqData.title,
            tag: JSON.stringify(faqData.tag || []),
            answer: JSON.stringify(faqData.data),
            relationInfo: JSON.stringify(faqData.relationInfo || []),
        };

        const result = await props.EditFAQ(data);

        if (result.status === 200) {
            showToast('success', "저장되었습니다.");
            props.setEditPopup();
        } else {
            showToast('danger', result.message);
        }
    }
    const handleCancle = () => {
        props.setEditPopup();
    }

    const tag = () => {
        return (
            <div className="related-item tag">
                <div className="cate-top">
                    <h4 className="cate-title">태그</h4>
                </div>
                <div class="searchbox-tag">
                    <i className="icoKdc20 add-g"></i>
                    <input type="text" placeholder="태그를 입력하고 엔터를 누르세요." onKeyDown={handleEnterTag} />
                </div>
                <div className="tag-list">
                    {faqData.tag?.map((x, index) => {
                        return (
                            <div className="tag-each" key={index}>
                                <span className="">{x}</span>
                                <button onClick={() => handleDeleteTag(x)}>
                                    <i className="icoKdc12 delete"></i>
                                </button>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }

    const relationInfo = () => {
        return (
            <div className="doclist-wrap">
                <div className="cate-top">
                    <h4 className="cate-title">관련문서</h4>
                    <button className="btn-add" onClick={e => openSearchDoc(e)} >
                        <i className="icoKdc20 add-g"></i>
                    </button>
                </div>
                {
                    faqData.relationInfo?.map((x, index) => {
                        return (
                            <div key={index} className="doclist">
                                <div className="doclist-title">
                                    <p>{path(x.fullPath ? JSON.parse(x.fullPath) : [])}</p>
                                    <p className='docbox-col-title'>{x.title}</p>
                                </div>
                                <button className="btn-delete" onClick={e => removeRelatedDoc(x)}>
                                    <i className="icoKdc20 delete"></i>
                                </button>
                            </div>
                        );
                    }
                    )
                }
            </div>
        )
    };

    const related = () => {
        return isSideBar && (
            <div class="related">
                <div className="faq-close">
                    <button className="btn-close" onClick={e => setIsSideBar(false)}><i className="icoKdc16 delete"></i></button>
                </div>
                {tag()}
                {relationInfo()}
            </div>
        )
    };

    const top = () => {
        return (
            <div className="faq-cnts-top">
                <div className="faq-cate">
                    <select id="faqKind" value={faqData.faqKindName ?? ""} onChange={(e) => selectFaqKind(e)} >
                        <option key={0} value={""} disabled>카테고리 선택</option>
                        {props.categoryList?.map((x, index) => {
                            return (
                                <option key={index} value={x.faqKindName}>{x.faqKindName}</option>
                            )
                        })}
                    </select>
                </div>
                <input className="faq-input" type='text' name="title" placeholder={"질문을 입력해 주세요."}
                    value={faqData.title ?? ""} onChange={handleTitle} />
                <button className="btn-info selected" onClick={e => setIsSideBar(prev => !prev)}><i className="icoKdc32 info-b"></i></button>
                <button className="btn-submit" onClick={handleSubmit}>저장</button>
            </div>
        )
    };

    const bottom = () => {
        return (
            <div class="faq-cnts-btm">
                <div className="faq-cnt-editor" style={{ overflowY: "auto" }}>
                    <Editor ViewMode={false} folderName={''} setEditorData={setFaqData} editorData={faqData} docId={faqID} 
                        setValid={setIsValid} />
                </div>
                {related()}
            </div>
        )
    };

    return (
        <>
            <div className="faq-wrap">
                <div class="faq-top">
                    <h3 className='title'>FAQ 추가</h3>
                    <button className="btn-close" onClick={handleCancle}>
                        <i className="icoKdc32 close"></i>
                    </button>
                </div>
                {top()}
                {bottom()}
                <PopUp content={popUpContent} setContent={setPopUpContent} />
            </div>
        </>
    )
}

export default FAQEditor;